import {
  PieChart,
  Pie,
  Legend,
  Cell,
  ResponsiveContainer,
  Label,
} from "recharts";

const CustomLegend = (props: any) => {
  const { payload } = props;

  return (
    <div className="legend d-flex justify-content-center">
      <table
        style={{
          fontSize: "smaller",
          color: "#545454",
        }}
      >
        <tbody className="row justify-content-center" style={{ gap: 10 }}>
          {payload.map((entry: any, index: number) => (
            <tr>
              <td className="legendColorBox">
                <div style={{ border: "1px solid #ccc", padding: 1 }}>
                  <div
                    style={{
                      width: 4,
                      height: 0,
                      border: `5px solid ${entry.payload.fill}`,
                      overflow: "hidden",
                    }}
                  />
                </div>
              </td>
              <td className="legendLabel" style={{ color: "var(--gray-dark)" }}>
                {entry.value} ({entry.payload.value})
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const CustomLabel = ({ viewBox, labelText, value }: any) => {
  const { cx, cy } = viewBox;
  return (
    <g>
      <text
        x={cx}
        y={cy}
        className="recharts-text recharts-label"
        style={{ color: "white" }}
        textAnchor="middle"
        dominantBaseline="central"
        alignmentBaseline="middle"
        fill="var(--gray-dark)"
        fontSize="15"
      >
        {labelText}
      </text>
      <text
        x={cx}
        y={cy + 20}
        className="recharts-text recharts-label"
        textAnchor="middle"
        dominantBaseline="central"
        alignmentBaseline="middle"
        fill="#0088FE"
        fontSize="26"
        fontWeight="600"
      >
        {value}
      </text>
    </g>
  );
};

type DataItem = {
  name: string;
  value: number;
  color: string;
};

type Props = {
  data: DataItem[];
  label: string;
  labelTotal: number;
  height: number;
};
export default function PieChartWithLegend({
  data,
  label,
  labelTotal,
  height,
}: Props) {
  return (
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <PieChart>
          <Legend content={<CustomLegend />} />

          <Pie data={data} dataKey="value" innerRadius={80} outerRadius={100}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
            <Label
              content={<CustomLabel labelText={label} value={labelTotal} />}
              position="center"
            />
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
